module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showNewsletter) ? _c('div', {
    staticClass: "row newsletter no-gutters w-100 innerbox-black gtm-onElementVisiblity",
    class: [{
      'hidden-overflow': _vm.submit
    }],
    style: ({
      height: _vm.newsletterWrapperHeight
    }),
    attrs: {
      "gtm-on": "elementVisibility",
      "gtm-visibility-category": _vm.gtmNewsletterCategory,
      "gtm-visibility-action": "Newsletter widget impression",
      "gtm-visibility-label": _vm.newsletterType.name
    }
  }, [_c('resize-observer', {
    on: {
      "notify": _vm.onResize
    }
  }), _c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-submit-form fadeInUp",
      "appear": ""
    }
  }, [(!_vm.submit) ? _c('div', {
    staticClass: "newsletter-form"
  }, [_c('form', {
    staticClass: "mx-auto",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row justify-content-center no-gutters",
    class: [{
      'active': _vm.submit
    }]
  }, [_c('div', {
    staticClass: "col-7 form-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.monsterEmail),
      expression: "monsterEmail",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "w-100 form-control border-0 pl-2 pr-2 input-email",
    class: {
      'warning-color': _vm.warning
    },
    attrs: {
      "type": "email",
      "placeholder": "your email"
    },
    domProps: {
      "value": (_vm.monsterEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.monsterEmail = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', {
    staticClass: "col-4 form-btn"
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn submit-newsletter pl-0 pr-0",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', [_vm._v("SIGN UP")])])])])]), _c('div', {
    staticClass: "notification warning",
    class: {
      'warning-color': _vm.warning
    }
  }, [(_vm.warning) ? _c('div', {
    staticClass: "d-flex align-items-center pr-3 pl-3 h-100"
  }, [_vm._v("Email Address is not valid.")]) : _vm._e()])])]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-submit-form fadeIn",
      "appear": ""
    }
  }, [(!_vm.submit) ? _c('div', {
    staticClass: "diamond-icon"
  }, [_c('svg-diamond-shape-icon')], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "appear": ""
    },
    on: {
      "after-enter": function($event) {
        _vm.animation('add')
      },
      "leave": function($event) {
        _vm.animation('remove')
      }
    }
  }, [(!_vm.submit) ? _c('div', {
    staticClass: "col-12 newsletter-inner-wrapper"
  }, [_c('div', {
    ref: "innerbox-0",
    staticClass: "innerbox first",
    class: _vm.newsletterType.color
  }, [_c('div', {
    ref: "innerbox-1",
    staticClass: "innerbox second",
    class: _vm.newsletterType.color
  }, [_c('div', {
    ref: "innerbox-2",
    staticClass: "innerbox third",
    class: _vm.newsletterType.color
  }, [_c('div', {
    ref: "innerbox-3",
    staticClass: "innerbox forth",
    class: _vm.newsletterType.color
  }, [_c('div', {
    ref: "innerbox-4",
    staticClass: "innerbox fifth",
    class: _vm.newsletterType.color
  }, [_c('div', {
    staticClass: " w-100"
  }, [(!_vm.submit) ? _c('div', {
    ref: "newsletterTextBox",
    staticClass: "w-100 newsletter-text-box d-flex align-items-center"
  }, [_c('div', {
    staticClass: "row no-gutters newsletter w-100 justify-content-center"
  }, [_c('div', {
    staticClass: "col-12 newsletter-text-content-wrapper"
  }, [_c('div', {
    staticClass: "text-wrapper"
  }, [_c('p', {
    staticClass: "title brand-title"
  }, [_vm._v("GET OUR")])]), _c('div', {
    staticClass: "text-wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "section-type",
    class: _vm.newsletterType.color
  }, [_vm._v(_vm._s(_vm.newsletterType.name))])])]), _c('div', {
    staticClass: "text-wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('span', {
    class: _vm.newsletterType.color
  }, [_vm._v("NEWSLETTER")])])])])])]) : _vm._e()])])])])])])]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-subscription-box fadeInDown-subscription",
      "leave-active-class": "animated-subscription-box fadeOut",
      "appear": ""
    },
    on: {
      "enter": _vm.play1
    }
  }, [(_vm.submit) ? _c('div', {
    staticClass: "subscription-box w-100 h-100",
    class: _vm.newsletterType.color
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-subscription-box fadeInDown-subscription",
      "leave-active-class": "animated-subscription-box fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "subscription first w-100 h-100",
    class: _vm.newsletterType.color
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-subscription-box fadeInDown-subscription",
      "leave-active-class": "animated-subscription-box fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "subscription second w-100 h-100",
    class: _vm.newsletterType.color
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-subscription-box fadeInDown-subscription",
      "leave-active-class": "animated-subscription-box fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "subscription third w-100 h-100",
    class: _vm.newsletterType.color
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-subscription-box fadeInDown-subscription",
      "leave-active-class": "animated-subscription-box fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "subscription forth w-100 h-100",
    class: _vm.newsletterType.color
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-subscription-box fadeInDown-subscription",
      "leave-active-class": "animated-subscription-box fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "subscription fifth monster-box w-100 h-100",
    class: _vm.newsletterType.color
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-newsletter-monster slideInDown",
      "leave-active-class": "animated-newsletter-mosnter fadeOut",
      "appear": ""
    },
    on: {
      "after-enter": function($event) {
        _vm.subscriptionText = true
      },
      "after-leave": function($event) {
        _vm.subscriptionText = false
      }
    }
  }, [_c('div', {
    staticClass: "monster-wrapper"
  }, [_c('div', {
    staticClass: "w-100 text-center monster"
  }, [_c('svg-email-monster-icon', {
    staticClass: "animated-monster"
  })], 1), _c('div', {
    staticClass: "monster-email animated-email"
  }, [_c('div', {
    staticClass: "row no-gutters justify-content-center mx-100 h-100"
  }, [_c('div', {
    staticClass: "col-3 text-center align-self-center"
  }, [_c('svg-email-black-icon')], 1), _c('div', {
    staticClass: "col-3 text-center align-self-center"
  }, [_c('svg-email-black-icon')], 1), _c('div', {
    staticClass: "col-3 text-center align-self-center"
  }, [_c('svg-email-black-icon')], 1)])])])]), (_vm.subscriptionText) ? _c('div', {
    staticClass: "monster-subscription mx-auto"
  }, [_c('transition', {
    attrs: {
      "duration": 500,
      "name": "monster-subscription-des1",
      "enter-active-class": "animated-newsletter-des1 fadeInDownDes1",
      "leave-active-class": "animated-newsletter-des1 fadeOut",
      "appear": ""
    },
    on: {
      "enter": _vm.play2
    }
  }, [(_vm.subscriptionText) ? _c('div', {
    staticClass: "section-type text-center"
  }, [_vm._v("THANK YOU")]) : _vm._e()]), _c('transition', {
    attrs: {
      "duration": 500,
      "name": "newsletter-subscription-des2",
      "enter-active-class": "animated-newsletter-des2 fadeInDownDes2",
      "leave-active-class": "animated-newsletter-des2 fadeOut",
      "appear": ""
    }
  }, [(_vm.subscriptionText) ? _c('div', {
    staticClass: "subscription-text pt-2 pl-1 pr-1 mx-auto"
  }, [_c('div', {
    staticClass: "row no-gutters justify-content-center"
  }, [_c('div', {
    staticClass: "col-11 text-center",
    class: _vm.newsletterType.color
  }, [_vm._v("\n                                    YOU ARE NOW ON THE EMAIL LIST\n                                  ")])])]) : _vm._e()])], 1) : _vm._e()], 1)])], 1)])], 1)])], 1)])], 1)])], 1) : _vm._e()])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59c8e79a","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/widgets/MonsterNewsletterForm.vue
// module id = 1103
// module chunks = 1 2 3